/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/rules-of-hooks */
import { useInfiniteList } from 'context/ResourceProvider/hooks/useInfiniteList';
import React, { useMemo } from 'react';
import debounce from 'lodash/debounce';
import omit from 'lodash/omit';
import get from 'lodash/get';

export const WithInfiniteOptions = (WrappedComponent) => {
  return (props) => {
    //provide transform filters, sorters and pagination
    const {
      resource,
      pagination,
      filters,
      sorters,
      onBlur,
      onFilterParams,
      transformOptions,
      labelKey = 'name',
      skip = false,
      loading: propLoading,
    } = props;
    const [keywords, setKeywords] = React.useState('');
    const _filters = useMemo(() => {
      const nextFilters = {
        ...filters,
      };

      if (keywords) {
        nextFilters['keywords'] = keywords;
        // nextFilters['searchBy'] = 'All';
      }
      if (onFilterParams) {
        //Transform The filter params before sending to the server
        return onFilterParams(nextFilters);
      }
      return nextFilters;
    }, [keywords, filters]);

    const { data, loading, hasNextPage, fetchNextPage } = useInfiniteList({
      resource: resource, //resource,
      filters: _filters,
      sorters,
      pagination,
      skip,
    });

    const allPages = React.useMemo(() => {
      if (transformOptions) {
        return transformOptions(
          [].concat(...(data?.pages ?? []).map((page) => page.data)),
          keywords
        );
      }
      return [].concat(...(data?.pages ?? []).map((page) => page.data)).map((item) => {
        const { id, name } = item;
        return { label: get(item, labelKey) || name, value: id, data: item };
      });
    }, [JSON.stringify(data), transformOptions, labelKey, keywords]);

    const debouncedSearch = React.useCallback(
      debounce((keywords) => {
        setKeywords(keywords);
      }, 500),
      []
    );

    const handleScroll = (e) => {
      const { target } = e;
      if (loading) return false;
      if (!hasNextPage) return;
      if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        fetchNextPage();
      }
    };

    return (
      <WrappedComponent
        {...omit(props, ['transformOptions', 'labelKey'])}
        options={allPages}
        showSearch
        onSearch={debouncedSearch}
        onSelect={() => {
          if (keywords) {
            //Clear the search
            debouncedSearch('');
          }
        }}
        onBlur={(e) => {
          if (keywords) {
            //Clear the search
            debouncedSearch('');
          }
          if (onBlur) {
            onBlur(e);
          }
        }}
        loading={loading || propLoading}
        filterOption={false}
        onPopupScroll={handleScroll}
      />
    );
  };
};
